import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../../../../modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.LICENSE_INVENTORY_ALLOCATION,
  mutations: {
    init() {
      return {
        queryObj: {
          search: {
            field: 'group_name',
            query: ''
          },
          filters: {},
          sort: {
            fields: ['group_name', 'group_id'],
            direction: 'asc',
            limit: 10,
            is_forward: true
          }
        },
        tableConfig: [],
        searchTargetUrl: '',
        hasMore: false,
        level: 0,
        loading: false,
        licenseAllocations: [],
        selectedGroups: [],
        allocationDrilldown: [],
        currentGroupLicenseCount: {
          assigned: 0,
          available: 0,
          redeemed: 0,
          total: 0,
        },
        childGroupLicenseCount: {
          assigned: 0,
          available: 0,
          redeemed: 0,
          total: 0,
        },
        activeRow: {},
      };
    },
    setQuerySearchQuery(subState, query) {
      return deepAssign(subState, 'queryObj.search', {
        query
      });
    },
    setQuerySearchField(subState, field) {
      return deepAssign(subState, 'queryObj.search', {
        field
      });
    },
    setQuerySortFields(subState, field) {
      return deepAssign(subState, 'queryObj.sort', {
        fields: [field, 'id']
      });
    },
    setQueryFilters(subState, filters) {
      return deepAssign(subState, 'queryObj', {
        filters
      });
    },
    removeSortLastValues(subState) {
      const nextSubState = deepAssign(subState, 'queryObj.sort', {});

      nextSubState.queryObj.sort.is_forward = true;
      if (typeof nextSubState.queryObj.sort.last_values !== 'undefined') {
        delete nextSubState.queryObj.sort.last_values;
      }

      return nextSubState;
    },
    updateSortOrder(subState, {index, field}) {
      let direction = subState.queryObj.sort.direction;
      if (direction === 'asc') {
        direction = 'desc';
      } else if (direction === 'desc') {
        direction = '';
      } else {
        direction = 'asc';
      }

      let fields = [field];
      if (fields.length === 0) {
        fields.push('group_name');
      }
      if (direction === '') {
        fields = ['group_name'];
        direction = 'asc';
      }

      return deepAssign(subState, 'queryObj.sort', {
        direction,
        fields: fields
      });
    },
    addToAllocationDrilldown(subState, row) {
      const allocationDrilldown = [...subState.allocationDrilldown];
      allocationDrilldown.push(row);
      return deepAssign(subState, '', {
        allocationDrilldown
      });
    },
    sliceAllocationDrilldown(subState, index) {
      const allocationDrilldown = subState.allocationDrilldown.slice(0, index);
      return deepAssign(subState, '', {
        allocationDrilldown
      });
    },
  },
  decorators: [
    (nextState) => { // $orderedLicenseAllocations
      const currState = storeInstance.getState()[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      if (
          typeof nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION].$orderedLicenseAllocations === 'undefined' ||
          currState.licenseAllocations !== nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION].licenseAllocations
      ) {
        const $orderedLicenseAllocations = {};
        nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION].licenseAllocations.map((allocation) => {

          let fullPath = allocation.group_path;
          if (fullPath === '') {
            fullPath = allocation.group_id + '.';
          }
          if (typeof $orderedLicenseAllocations[fullPath] === 'undefined') {
            $orderedLicenseAllocations[fullPath] = [];
          }
          $orderedLicenseAllocations[fullPath].push(allocation);
        });
        nextState = deepAssign(nextState, sdoNs.LICENSE_INVENTORY_ALLOCATION, {$orderedLicenseAllocations});

      }
      return nextState;
    },
    (nextState) => { // prev search query
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      const subState = state[sdoNs.LICENSE_INVENTORY_ALLOCATION];

      if (typeof nextSubState.$prevQueryObj === 'undefined' || nextSubState.queryObj !== subState.queryObj) {
        const $prevQueryObj = subState.queryObj;

        nextState = deepAssign(nextState, `${sdoNs.LICENSE_INVENTORY_ALLOCATION}`, {$prevQueryObj});
      }

      return nextState;
    },
    (nextState) => { // prev pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      const subState = state[sdoNs.LICENSE_INVENTORY_ALLOCATION];

      if (typeof nextSubState.$prev === 'undefined' || nextSubState.licenseAllocations !== subState.licenseAllocations) {
        let $prev = '';
        if (nextSubState.licenseAllocations.length > 0) {
          $prev = nextSubState.licenseAllocations[0]; /** @todo assign needed props */
          $prev.id = $prev.group_id;
        }
        nextState = deepAssign(nextState, `${sdoNs.LICENSE_INVENTORY_ALLOCATION}`, {$prev});
      }

      return nextState;
    },
    (nextState) => { // next pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      const subState = state[sdoNs.LICENSE_INVENTORY_ALLOCATION];

      if (typeof nextSubState.$next === 'undefined' ||
          nextSubState.licenseAllocations !== subState.licenseAllocations) {
        let $next = '';
        if (nextSubState.licenseAllocations.length > 0) {
          $next = nextSubState.licenseAllocations[nextSubState.licenseAllocations.length - 1]; /** @todo assign needed props */
          $next.id = $next.group_id;
        }
        nextState = deepAssign(nextState, `${sdoNs.LICENSE_INVENTORY_ALLOCATION}`, {$next});
      }

      return nextState;
    },
    (nextState) => { // $sort to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      const subState = state[sdoNs.LICENSE_INVENTORY_ALLOCATION];

      if (typeof nextSubState.$sort === 'undefined' ||
          nextSubState.queryObj.sort !== subState.queryObj.sort) {
        const $sort = Object.assign({}, nextSubState.queryObj.sort);
        if ($sort.direction === '') {
          $sort.direction = 'asc';
        }

        nextState = deepAssign(nextState, sdoNs.LICENSE_INVENTORY_ALLOCATION, {
          $sort
        });
      }

      return nextState;
    },
    (nextState) => { // $pageNumber, $numPages
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.LICENSE_INVENTORY_ALLOCATION];
      const subState = state[sdoNs.LICENSE_INVENTORY_ALLOCATION];

      if (
          typeof nextSubState.$pageNumber === 'undefined' ||
          nextSubState.hasMore !== subState.hasMore ||
          nextSubState.$sort !== subState.$sort
      ) {
        const hasOffset = Boolean(nextSubState.$sort.last_values);
        let $pageNumber = 1;
        let $numPages = 7;

        if (nextSubState.$sort.is_forward) {
          if (hasOffset) {
            $pageNumber = 2;
          }

          if (!nextSubState.hasMore) {
            $numPages = $pageNumber;
          }
        } else {
          $pageNumber = nextSubState.hasMore ? 2 : 1;
        }

        nextState = deepAssign(nextState, `${sdoNs.LICENSE_INVENTORY_ALLOCATION}`, {$pageNumber, $numPages});
      }

      return nextState;
    },

  ]
};

storeInstance.addState(sdo);
